// What to tell a person when a call to the API fails, in one place.

// The server's own explanation if it sent one ("The task title can't be empty"), otherwise the error's message, otherwise
// the fallback.
export const apiErrorMessage = (error: any, fallback = 'Something went wrong'): string =>
    error?.response?.data?.message ?? error?.message ?? fallback;

// The request never got an answer (offline, server down), as opposed to the server refusing it.
export const isNetworkError = (error: any): boolean =>
    !!error?.isAxiosError && !error.response;
